import React, { useEffect, useState} from "react";
import qs from "qs";
//import { useNavigate} from 'react-router-dom';
//import { useBlocker } from 'react-router-dom';
import {
    Box,
    Typography,
    Button,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Checkbox,
    Grid, ListItemText,
    //Box,
} from "@mui/material";
import { BarChart } from '@mui/x-charts/BarChart';

/*import OrderDetailsGrid from "./OrderDetailsGrid.tsx";*/
/*import EmailConversation from "./EmailConversation";*/
import { Customer, User, OrderType, OrderState, OrdersCount } from "../types";

import Layout from "../components/Layout";
import { API_BASE_URL } from "../config.ts";
import { CreatedOnFilter, getCreatedOnRange } from "../utils/helpers.ts";

import axiosExt from '../axios';

//import dayjs from 'dayjs';
//import 'dayjs/locale/en';
//import 'dayjs/locale/de';
//import 'dayjs/locale/en-gb';
//import 'dayjs/locale/zh-cn';
//import { DatePicker } from "@mui/x-date-pickers";
//import { LocalizationProvider } from "@mui/x-date-pickers";
//import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from "react-i18next";

//const locales = ['en', 'en-gb', 'zh-cn', 'de'];
//type LocaleKey = (typeof locales)[number];

const ReportsOrderStatusPage = () => {
    //const navigate = useNavigate();
    const { t } = useTranslation();

    //const [order, setOrder] = useState<Order>();
    //const [orders, setOrders] = useState<Order[]>([]);
    const [customers, setCustomers] = useState<Customer[]>([]);
    //const [contacts, setContacts] = useState<Contact[]>([]);
    //const [contactsLoading, setContactsLoading] = useState<boolean>(true);
    const [user, setUser] = useState<User>();
    //const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState<User[]>([]);
    //const [orderTypes, setOrderTypes] = useState<OrderType[]>([]);
    const [orderStates, setOrderStates] = useState<OrderState[]>([]);
    //const [detailStates, setDetailStates] = useState<DetailState[]>([]);
    //const [services, setServices] = useState<Service[]>([]);
    //const [locale, setLocale] = React.useState<LocaleKey>('de');
  
    //filtering 
    const [filterCustomer, setFilterCustomer] = useState<string>("");
    const [filterAssignedTo, setFilterAssignedTo] = useState<string>(user?.id || ""); // Default to current user
    //const [filterType, setFilterType] = useState<string>("all");
    const [filterState, setFilterState] = useState<string[]>([]);
    const [filterPreviousState, setFilterPreviousState] = useState<string[]>([]);
    const [filterCreatedOn, setFilterCreatedOn] = useState<string>("this_month");
    //const [filterDueDate, setFilterDueDate] = useState<string>("this_month");
    //const [filterNewEmail, setFilterNewEmail] = useState<string>("all");

    //order statistics
    const [statisticData, setStatisticData] = React.useState<OrdersCount[]>([]);
    const sortedStates = [...statisticData].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

    const fetchOrdersStatistics = async () => {
        try {
            const token = localStorage.getItem("token");

            const savedFilters = localStorage.getItem("orderStatusReportFilter");

            let parsedFilters = {
                filterCustomer: "",
                filterAssignedTo: "",
                filterState: [],
                filterPreviousState:[],
                filterCreatedOn: "this_month",
                //filterDueDate: "this_month",
            };

            if (savedFilters) {
                parsedFilters = JSON.parse(savedFilters);
                setFilterCustomer(parsedFilters.filterCustomer);
                setFilterAssignedTo(parsedFilters.filterAssignedTo);

                //setFilterState(parsedFilters.filterState);
                const restoredFilterState = parsedFilters.filterState;
                setFilterState(Array.isArray(restoredFilterState) ? restoredFilterState : []);

                const restoredFilterPreviouState = parsedFilters.filterPreviousState;
                setFilterPreviousState(Array.isArray(restoredFilterPreviouState) ? restoredFilterPreviouState : []);

                setFilterCreatedOn(parsedFilters.filterCreatedOn);
                //setFilterDueDate(parsedFilters.filterDueDate);
            };

            const filterFields = [];
            const filterOperations = [];
            const filterValues = [];

            if (parsedFilters.filterCustomer && parsedFilters.filterCustomer !== "all_customers") {
                filterFields.push("CustomerGuid");
                filterOperations.push("Equals");
                filterValues.push(parsedFilters.filterCustomer);
            }

            if (parsedFilters.filterAssignedTo && parsedFilters.filterAssignedTo !== "all_users") {
                filterFields.push("AssignedToUserGuid");
                filterOperations.push("Equals");
                filterValues.push(parsedFilters.filterAssignedTo);

            }

            if (parsedFilters.filterState && parsedFilters.filterState.length > 0) {
                filterFields.push("StateGuid");
                filterOperations.push("In"); // or your API-specific 'Contains', 'In', etc.
                //filterValues.push(parsedFilters.filterState);
                filterValues.push(parsedFilters.filterState.join(","));
            }

            if (parsedFilters.filterPreviousState && parsedFilters.filterPreviousState.length > 0) {
                filterFields.push("PreviousStateGuid");
                filterOperations.push("In"); // or your API-specific 'Contains', 'In', etc.
                //filterValues.push(parsedFilters.filterState);
                filterValues.push(parsedFilters.filterPreviousState.join(","));
            }


            // Handle CreatedOn filter by building a date range
            const createdOnRange = getCreatedOnRange(parsedFilters.filterCreatedOn as CreatedOnFilter);
            if (createdOnRange) {
                const startString = createdOnRange.start.format("YYYY-MM-DDTHH:mm:ss");
                const endString = createdOnRange.end.format("YYYY-MM-DDTHH:mm:ss");

                // CreatedDateTime >= start
                filterFields.push("CreatedDateTime");
                filterOperations.push("OnOrAfter");
                filterValues.push(startString);

                // CreatedDateTime <= end
                filterFields.push("CreatedDateTime");
                filterOperations.push("OnOrBefore");
                filterValues.push(endString);
            }

            //// Handle Due Date filter by building a date range
            //const dueDateRange = getCreatedOnRange(parsedFilters.filterDueDate as CreatedOnFilter);
            //if (dueDateRange) {
            //    const startString = dueDateRange.start.format("YYYY-MM-DDTHH:mm:ss");
            //    const endString = dueDateRange.end.format("YYYY-MM-DDTHH:mm:ss");

            //    // DueDate >= start
            //    filterFields.push("DueDate");
            //    filterOperations.push("OnOrAfter");
            //    filterValues.push(startString);

            //    // DueDate <= end
            //    filterFields.push("DueDate");
            //    filterOperations.push("OnOrBefore");
            //    filterValues.push(endString);
            //}

            const params = {
                filterFields,
                filterOperations,
                filterValues,
            };

            const response = await axiosExt.get(`${API_BASE_URL}/orders/get-orders-statistics?`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                params: params,
                paramsSerializer: {
                    serialize: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
                },
            });

            setStatisticData(response.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    }

    useEffect(() => {
        //fetchServices();
        fetchOrderTypes();
        fetchOrderStates();
        //fetchDetailStates();
        fetchCustomers();

        fetchUser();
        fetchUsers();

        fetchOrdersStatistics();
    }, []);

    /*const fetchServices = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get<Service[]>(`${API_BASE_URL}/services`, {
                headers: { "Authorization": `Bearer ${token}` },
            });
            setServices(response.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    };*/
    const fetchOrderTypes = async () => {
        //setLoading(true);

        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get<OrderType[]>(`${API_BASE_URL}/orderTypes/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            //setOrderTypes(response.data);
        } catch (error) {
            console.error("Error fetching orderTypes:", error);
        } finally {
            //setLoading(false);
        }
    }

    const fetchOrderStates = async () => {
        //setLoading(true);

        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get<OrderState[]>(`${API_BASE_URL}/orderStates/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setOrderStates(response.data);
        } catch (error) {
            console.error("Error fetching order states:", error);
        } finally {
            //setLoading(false);
        }
    }

    /*const fetchDetailStates = async () => {
        //setLoading(true);

        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get<DetailState[]>(`${API_BASE_URL}/detailStates/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setDetailStates(response.data);
        } catch (error) {
            console.error("Error fetching detail states:", error);
        } finally {
            setLoading(false);
        }
    }*/

    const fetchUsers = async () => {
        //setLoading(true);

        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get<User[]>(`${API_BASE_URL}/users/roles/admin-support`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }
            console.log("3 Setting users to:", response.data);
            setUsers(response.data);
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            //setLoading(false);
        }
    }

    const fetchCustomers = async () => {
        const token = localStorage.getItem("token");

        try {
            const response = await axiosExt.get<Customer[]>(`${API_BASE_URL}/customers`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }

            );

            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setCustomers(response.data);
        } catch (error) {
            console.error("Error fetching customers:", error);
        }
    };

    const fetchUser = async () => {
        //setLoading(true);

        try {
            const token = localStorage.getItem("token");
            const userId = localStorage.getItem("userId");
            //const searchParam = customerId ? `search=${customerId}` : "";
            const response = await axiosExt.get<User>(`${API_BASE_URL}/users/${userId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {

                throw new Error("Unauthorized. Please log in again.");
            }
            setUser(response.data);

        } catch (error) {
            console.error("Error fetching user:", error);
        } finally {
            //setLoading(false);
            /*console.log(order);*/
        }


    };

    
    return (
            <Layout>
                <Box display="flex" width="100%" height="100vh" marginLeft="0px" paddingLeft="0px" marginRight="10px" paddingRight="10px">
                    {/* Column 1: Orders List */}
                    <Box width="20%" display="flex" flexDirection="column" marginLeft="0px" paddingLeft="0px" marginRight="10px">
                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                            <Typography variant="h4">{t("Orders Status")}</Typography>
                        </Box>


                        <Box sx={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto", overflowX: "clip", width: "100%", marginLeft: "0px", paddingLeft: "0px", marginTop: "0px" }}>
                                <Box padding={2} borderBottom={1} width="100%" marginLeft="0" paddingLeft="0" marginRight="5px" paddingRight="10px" marginTop="0px">
                                    <Grid container spacing={1} marginLeft="0px" paddingLeft="0px">
                                        {/* Left Column */}
                                        <Grid item xs={12} sm={6} marginLeft="0px" paddingLeft="0px" sx={{ marginLeft: "0px", paddingLeft: "0px" }}>
                                            <FormControl fullWidth sx={{ marginLeft: "0px", paddingLeft: "0px", marginTop: 2 }}>
                                                <InputLabel>{t("Customer")}</InputLabel>
                                                <Select value={filterCustomer} onChange={(e) => setFilterCustomer(e.target.value)}>
                                                    <MenuItem value="all_customers">{t("All Customers")}</MenuItem>
                                                    {customers.map((customer) => (
                                                        <MenuItem key={customer.id} value={customer.id}>{customer.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <FormControl fullWidth sx={{ marginTop: 2, marginLeft: "0px", paddingLeft: "0px" }}>
                                                <InputLabel>{t("Assigned To")}</InputLabel>
                                                <Select value={filterAssignedTo} onChange={(e) => setFilterAssignedTo(e.target.value)}>
                                                    <MenuItem value="all_users">{t("All")}</MenuItem>
                                                    {users.map((user) => (
                                                        <MenuItem key={user.id} value={user.id}>{user.userName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <FormControl fullWidth sx={{ marginTop: 2, marginLeft: "0px", paddingLeft: "0px" }}>
                                                <InputLabel>{t("State")}</InputLabel>
                                                <Select
                                                    multiple
                                                    value={filterState}
                                                    onChange={(e) => setFilterState(e.target.value as string[])}
                                                    renderValue={(selected) =>
                                                        orderStates
                                                            .filter((state) => state.id && selected.includes(state.id))
                                                            .map((state) => state.name)
                                                            .join(", ")
                                                    }
                                                >
                                                {orderStates
                                                    .sort((a, b) => {
                                                        if (a.sortOrder !== b.sortOrder) {
                                                            return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
                                                        }
                                                        return a.name.localeCompare(b.name);
                                                    })
                                                    .map((state) => (
                                                    <MenuItem key={state.id ?? "unknown"} value={state.id ?? ""}>
                                                        <Checkbox checked={typeof state.id === "string" && filterState.includes(state.id)} />
                                                        <ListItemText primary={state.name} />
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        {/* Right Column */}
                                        <Grid item xs={12} sm={6} marginLeft="0px" paddingLeft="0px" sx={{ marginLeft: "0px" }}>
                                            <FormControl fullWidth sx={{ marginTop: 2 }}>
                                                <InputLabel>{t("Created On")}</InputLabel>
                                                <Select value={filterCreatedOn} onChange={(e) => setFilterCreatedOn(e.target.value)}>
                                                    <MenuItem value="all">{t("All")}</MenuItem>
                                                    <MenuItem value="today">{t("Today")}</MenuItem>
                                                    <MenuItem value="yesterday">{t("Yesterday")}</MenuItem>
                                                    <MenuItem value="this_week" >{t("This Week")}</MenuItem>
                                                    <MenuItem value="last_week" >{t("Last Week")}</MenuItem>
                                                    <MenuItem value="this_month" >{t("This Month")}</MenuItem>
                                                    <MenuItem value="last_month" >{t("Last Month")}</MenuItem>
                                                    <MenuItem value="last_30_days" >{t("Last 30 Days")}</MenuItem>
                                                    <MenuItem value="last_60_days" >{t("Last 60 Days")}</MenuItem>
                                                    <MenuItem value="last_90_days" >{t("Last 90 Days")}</MenuItem>
                                                </Select>
                                            </FormControl>

                                            {/*<FormControl fullWidth sx={{ marginTop: 2 }}>*/}
                                            {/*    <InputLabel>{t("Due On")}</InputLabel>*/}
                                            {/*    <Select value={filterDueDate} onChange={(e) => setFilterDueDate(e.target.value)}>*/}
                                            {/*        <MenuItem value="all">{t("All")}</MenuItem>*/}
                                            {/*        <MenuItem value="today">{t("Today")}</MenuItem>*/}
                                            {/*        <MenuItem value="yesterday">{t("Yesterday")}</MenuItem>*/}
                                            {/*        <MenuItem value="tomorrow">{t("Tomorrow")}</MenuItem>*/}
                                            {/*        <MenuItem value="this_week">{t("This Week")}</MenuItem>*/}
                                            {/*        <MenuItem value="last_week">{t("Last Week")}</MenuItem>*/}
                                            {/*        <MenuItem value="next_week">{t("Next Week")}</MenuItem>*/}
                                            {/*        <MenuItem value="this_month">{t("This Month")}</MenuItem>*/}
                                            {/*        <MenuItem value="last_month">{t("Last Month")}</MenuItem>*/}
                                            {/*        <MenuItem value="last_30_days" >{t("Last 30 Days")}</MenuItem>*/}
                                            {/*        <MenuItem value="last_60_days" >{t("Last 60 Days")}</MenuItem>*/}
                                            {/*        <MenuItem value="next_30_days" >{t("Next 30 Days")}</MenuItem>*/}
                                            {/*        <MenuItem value="next_60_days" >{t("Next 60 Days")}</MenuItem>*/}
                                            {/*    </Select>*/}
                                            {/*</FormControl>*/}


                                            <FormControl fullWidth sx={{ marginTop: 2, marginLeft: "0px", paddingLeft: "0px" }}>
                                                <InputLabel>{t("Previous State")}</InputLabel>
                                                <Select
                                                    multiple
                                                    value={filterPreviousState}
                                                    onChange={(e) => setFilterPreviousState(e.target.value as string[])}
                                                    renderValue={(selected) =>
                                                        orderStates
                                                            .filter((state) => state.id && selected.includes(state.id))
                                                            .map((state) => state.name)
                                                            .join(", ")
                                                    }
                                                >
                                            {orderStates
                                                .sort((a, b) => {
                                                    if (a.sortOrder !== b.sortOrder) {
                                                        return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
                                                    }
                                                    return a.name.localeCompare(b.name);
                                                })
                                                .map((state) => (
                                                        <MenuItem key={state.id ?? "unknown"} value={state.id ?? ""}>
                                                            <Checkbox checked={typeof state.id === "string" && filterPreviousState.includes(state.id)} />
                                                            <ListItemText primary={state.name} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            {/* Apply Filters Button */}
                                            <Box sx={{ marginTop: 2, textAlign: "right" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        const filters = {
                                                            filterCustomer,
                                                            filterAssignedTo,
                                                            filterState,
                                                            filterPreviousState,
                                                            filterCreatedOn,
                                                            //filterDueDate,
                                                        };

                                                        localStorage.setItem("orderStatusReportFilter", JSON.stringify(filters));
                                                        fetchOrdersStatistics();
                                                    }}
                                                >
                                                    {t("Apply Filters")}
                                                </Button>
                                            </Box>

                                        </Grid>
                                    </Grid>
                                </Box>
                        </Box>
                    </Box>

                    {/* Column 2: Chart */}
                    <Box width="80%" display="flex" flexDirection="column" padding="5px">
                        <Box display="flex" gap={2}>
                            <Box sx={{ flex: 1 }} margin="dense">
                                <BarChart
                                    margin={{ top: 20, bottom: 20, left: 60, right: 60 }}
                                    height={200}
                                    xAxis={[{
                                        data: sortedStates.map((d) => d.stateName),
                                        scaleType: 'band',
                                        colorMap: {
                                            type: 'ordinal',
                                            values: sortedStates.map((d) => d.stateName),
                                            colors: sortedStates.map((d) => d.stateColor),
                                        },
                                    }]}
                                series={[{ data: sortedStates.map((d) => d.orderCount) }]}
                                />

                            </Box>

                        </Box>
                    </Box>
                </Box>
            </Layout>
    );
};

export default ReportsOrderStatusPage;
